<template>
  <el-dialog
    :title="$t('member.memberCreate.existDialog.title')"
    :show-close="true"
    :visible="true"
    :width="width"
    :close-on-click-modal="false"
    @close="$emit('close')"
  >
    <span>{{ content }}</span>
    <span slot="footer" class="dialog-footer">
      <div class="flex justify-end" style="gap: 12px">
        <BaseElButton plain @click="$emit('close')">{{ $t('member.memberCreate.existDialog.back') }}</BaseElButton>
        <router-link :to="{name: 'MemberProfile', params: {id: member.id}}">
          <BaseElButton :loading="redirect" type="primary" @click="redirect = true">{{ redirect ? $t('member.memberCreate.existDialog.redirecting') : $t('member.memberCreate.existDialog.viewDetail') }}</BaseElButton>
        </router-link>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import { t } from '@/plugins/i18n/i18n'

export default {
  name: 'MemberExistDialog',
  props: {
    content: {
      type: String,
      default: () => t('member.memberCreate.existDialog.defaultContent'),
    },
    width: {
      type: String,
      default: '40%',
    },
    member: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    redirect: false,
  }),
}
</script>

<style lang="postcss" scoped>

</style>
